import { stats } from '@/mocks/data';

export default function StatsSection() {
  return (
    <section className="py-14 md:py-20 bg-gradient-to-r from-primary-600 to-primary-800">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat) => (
            <div key={stat.id} className="text-center">
              <div className="w-14 h-14 mx-auto flex items-center justify-center bg-background-50/15 rounded-full mb-4">
                <i className={`${stat.icon} text-2xl text-background-50`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-background-50/70">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}